/** @jsxImportSource @emotion/react */

import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import PageTemplate from '@page/iyagigo/page-template';
import ClassroomConversationStudy from '@component/iyagigo/classroom/classroom-conversation-study';
import { useTypedDispatch } from '@hook/common/useStore';
import { actions as modalActions } from '@store/slice/modal-slice';
import { actions as classroomActions } from '@store/slice/classroom-slice';
import HeaderProgress from '@component/iyagigo/common/header-progress';

const ClassroomConversationPage: React.FC = () => {
  const dispatch = useTypedDispatch();
  const [searchParams] = useSearchParams();
  const expressionStudyKey = searchParams.get('subject') ?? '';
  const [title, setTitle] = React.useState('생활회화 학습');
  const [progress, setProgress] = React.useState({ current: 0, total: 0 });

  useEffect(() => {
    dispatch(classroomActions.storeIsStudying(true));
    return () => {
      dispatch(classroomActions.storeIsStudying(false));
    };
  }, [dispatch]);

  const handleBackClick = () => {
    dispatch(
      modalActions.showDialogModal({
        type: 'workbook-quit',
        data: { mainMenu: 'classroom', subMenu: 'conversation' },
      }),
    );
  };

  return (
    <PageTemplate
      title={title}
      mode='close'
      handleNavigationClick={handleBackClick}
      customHeader={
        progress.total > 0 ? (
          <HeaderProgress currentProgress={progress.current} totalProgress={progress.total} />
        ) : undefined
      }>
      <ClassroomConversationStudy key={expressionStudyKey} onProgress={setProgress} onTitleChange={setTitle} />
    </PageTemplate>
  );
};

export default ClassroomConversationPage;
